import React from 'react';
import './CheckBox.scss';

const CheckBox = ({checked, label, onChange, containerStyle }) => {

    return (
        <div className='check-box'>
            <label className="container" style={ containerStyle }>{label !== '' ? label : null}
                <input type="checkbox" checked={checked} onChange={(e) => onChange()}/>
                <span className="checkmark"></span>
            </label>
        </div>
    )
}

export default CheckBox;